import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { IvyFaceAnimatedComponent } from "../../chat-gpt/components/ivy-face-animated/ivy-face-animated.component";
import { CommonModule } from '@angular/common';
import { UserInfoService } from 'projects/chat-common/src/lib/services/user.info.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-consent',
  templateUrl: './consent.component.html',
  standalone: true,
  imports: [IvyFaceAnimatedComponent, CommonModule, ReactiveFormsModule, FormsModule]
})
export class ConsentComponent implements OnInit {
  @Output() accepted = new EventEmitter<void>(); // javlja roditelju da je pristao
  isLoading = false;

  consentForm = this.fb.group({
    accept: [false, Validators.requiredTrue],
  });

  constructor(
    private fb: FormBuilder, 
    private userInfoService: UserInfoService,
    private router: Router
) {}

 async ngOnInit() {
   let permission = await this.userInfoService.getUserChatPermission();
 }

  async onSubmit() {
    if (this.consentForm.invalid) return;
    this.isLoading = true;

    await this.userInfoService.saveUserChatPermission(true);
    this.router.navigate(['/login']);

    setTimeout(() => {
      this.isLoading = false;
      this.accepted.emit();
    }, 150);
  }
}
